import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { ChangeDetectionStrategy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { lyl, WithStyles, StyleRenderer, ThemeVariables, ThemeRef } from '@alyle/ui';
import {
  STYLES as CROPPER_STYLES,
  LyImageCropper,
  ImgCropperConfig,
  ImgCropperEvent,
  ImgCropperErrorEvent,
  ImgCropperLoaderConfig,
  ImgResolution
} from '@alyle/ui/image-cropper';
import { Platform } from '@angular/cdk/platform';
import { LySliderChange } from '@alyle/ui/slider';

const STYLES = (_theme: ThemeVariables, ref: ThemeRef) => {
  ref.renderStyleSheet(CROPPER_STYLES);
  const cropper = ref.selectorsOf(CROPPER_STYLES);

  return {
    root: lyl`{
      ${cropper.root} {
        max-width: 250px
        height: 250px
      }
    }`,
    sliderContainer: lyl`{
     

      color:#000
    }`,
    cropResult: lyl`{
      border-radius: 50%
    }`
  };


};

@Component({
  selector: 'app-image-editor-tool',
  templateUrl: './image-editor-tool.component.html',
  styleUrls: ['./image-editor-tool.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    StyleRenderer
  ],
  standalone: false,
})
export class ImageEditorToolComponent {

  zoomLevel: number = 1; // Initial zoom level
  scale: number;
  ready: boolean = false;
  classes = this.sRenderer.renderSheet(STYLES, 'root');
  croppedImage?: string;
  // scale: number;
  // ready: boolean;
  minScale: number;
  maxScale: number = 1;
  // @ViewChild(LyImageCropper, { static: true }) readonly cropper: LyImageCropper;
  @ViewChild(LyImageCropper, { static: false }) cropper: LyImageCropper | undefined;
  myConfig: ImgCropperConfig = {
    width: 250,
    height: 250,

    type: 'image/jpeg',
    round: true,
    keepAspectRatio: true,
    responsiveArea: true,
    fill: '#E9E9E9',
    output: ImgResolution.OriginalImage,
  };

  //custom
  imageChangedEvent: any = '';
  isFront: boolean = false;
  originalImageFile;
  isSupplementary: boolean = false;
  supplementaryIndex: number = -1

  constructor(
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any,
    readonly sRenderer: StyleRenderer,
    private _platform: Platform,
    private dialogRef: MatDialogRef<ImageEditorToolComponent>,
    private cdr: ChangeDetectorRef
  ) {


    this.originalImageFile = data.file;
    this.isFront = data.isFront;
    this.isSupplementary = data.isSupplimentry;
    this.supplementaryIndex = data.supplimentryIndex;
    this.imageChangedEvent = { target: { files: [data.file] } };

  }

  convertFileToBase64(file: File, callback: (result: string | ArrayBuffer) => void) {
    const reader = new FileReader();
    reader.onload = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  }



  ngAfterViewInit() {
    if (this.cropper && this._platform.isBrowser) {
      this.convertFileToBase64(this.data.file, (base64Data: string) => {
        const config: ImgCropperLoaderConfig = {
          originalDataURL: base64Data
        };
        this.cropper.loadImage(config);

        this.ready = true;
        this.cdr.markForCheck();
      });
    }
  }

  onCropped(e: ImgCropperEvent) {
    this.croppedImage = e.dataURL;
    this.cdr.markForCheck();

    // this.applyChanges();
  }
  onLoaded(e: ImgCropperEvent) {
    if (e.type === 'loaded') {
      this.minScale = e.scale || 0.1;
      this.maxScale = Math.max(1, this.minScale * 5); // Ensure max is always sufficiently larger than min
      this.scale = e.scale || 1;
      this.cdr.markForCheck();
    }
  }
  onError(e: ImgCropperErrorEvent) {
    // console.warn(`'${e.name}' is not a valid image`, e);
  }
  onSliderInput(event: LySliderChange) {
    this.scale = event.value as number;
  }

  // onZoomChange(event: any): void {
  //   this.zoomLevel = Math.min(200, Math.max(0, parseInt(event.target.value)));
  // }

  onZoomChange(event: any): void {
    const newZoom = Math.min(200, Math.max(1, parseInt(event.target.value)));
    this.zoomLevel = newZoom;
    this.scale = newZoom / 100;
    console.log('Zoom level:', this.zoomLevel);
  }


  onReady() {
    if (this.cropper) {
      this.cropper.scale = this.scale; // Directly apply scale when the cropper is ready
    }
  }

  zoomIn() {
    this.cropper?.zoomIn();
  }

  zoomOut() {
    this.cropper?.zoomOut();
  }

  crop() {
    this.cropper?.crop();
  }

  applyChanges(): void {
    if (this.croppedImage) {
      const imageBlob = this.dataURLtoBlob(this.croppedImage);
      const data = { isEdit: true, image: imageBlob, isFront: this.isFront, isSupplementary: this.isSupplementary, supplementaryIndex: this.supplementaryIndex };
      this.dialogRef.close(data);
    } else {
      console.error('Cropped image data is undefined');
    }
  }

  dataURLtoBlob(dataURL: string): Blob {

    if (!dataURL) {
      throw new Error('Invalid dataURL');
    }

    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }

  cancel(): void {
    this.dialogRef.close({ isEdit: false, image: this.originalImageFile });
  }

}

